<template>
  <v-container fluid>
    <NonConformitiesTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <!-- <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="$t('actions.export', { entity: $tc('categories.nonconformity.name', 2) })"
        /> -->
        <avs-button
          :data="dataset"
          color="secondary"
          iconI="mdi-export"
          :spantext="
            $t('actions.export', {
              entity: $tc('categories.nonconformity.name', 2).toLowerCase()
            })
          "
          text
          @click="exportToExcel()"
        >
          <template v-slot:name>
            {{ $t("actions.export_") }}
          </template>
        </avs-button>
        <avs-createButton
          :to="{ name: 'NonConformityCreateUpdate' }"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.nonconformity.name', 1).toLowerCase()
            })
          "
          :name="
            $t('actions.new_female', {
              entity: $tc('categories.nonconformity.name', 1).toLowerCase()
            })
          "
        />
      </template>
    </NonConformitiesTable>
  </v-container>
</template>
<script>
import { NonConformitiesTable } from "@/components"
import { fmtNonConformityData } from "@/utils/download"
import NonConformityService from "@/services/NonConformityService"
import { toDate } from "@/utils/datetime"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

export default {
  name: "NonConformitiesView",
  components: { NonConformitiesTable },
  computed: {
    project() {
      return this.$store.state.app.project
    }
  },
  methods: {
    preFmtData(dataset) {
      return fmtNonConformityData(dataset)
    },
    async exportToExcel() {
      // 1. Récupérer toutes les NC (avec ou sans filtre inspection)
      let resp = await NonConformityService.get(this, this.project.id)
      const allData = resp.results
      if (!allData.length) {
        return this.$store.commit("app/message", {
          msg: this.$t("messages.warning.no_data_to_export"),
          color: "warning"
        })
      }

      // 2. Titre et nom de feuille
      const rawTitle = this.$tc("categories.nonconformity.name", 2).toUpperCase() // p.ex. "NONCONFORMITIES"
      const sheetName = rawTitle.slice(0, 31)

      // 3. En‑têtes traduites
      const baseHeaders = [
        this.$t("commons.nc_number"),
        this.$t("commons.date.report_date"),
        this.$t("categories.nonconformity.area"),
        this.$t("categories.nonconformity.event"),
        this.$t("categories.nonconformity.other"),
        this.$t("commons.status.name"),
        this.$t("commons.criticality"),
        this.$t("categories.nonconformity.due_to"),
        this.$t("commons.total_actions"),
        this.$t("commons.created_by")
      ]
      // si on n'est PAS dans le contexte d'une inspection, ajouter la colonne Inspection
      const headers = this.inspectionId
        ? baseHeaders
        : [this.$t("commons.inspection"), ...baseHeaders]

      // 4. Préparer les lignes de données
      const exportData = allData.map(item => {
        const row = []
        if (!this.inspectionId) {
          row.push(item.inspection?.name || "N/A")
        }
        row.push(
          item.nc_number,
          toDate(item.report_date),
          item.area,
          item.event,
          item.other,
          item.status,
          item.criticality,
          item.due_to,
          item.total_actions,
          item.created_by?.username || item.created_by
        )
        return row
      })

      // 5. Créer le classeur et la feuille
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet(sheetName)

      // 6. Titre en A1 (fusion sur le nombre de colonnes)
      ws.mergeCells(1, 1, 1, headers.length)
      ws.getCell("A1").value = rawTitle
      ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle" }
      ws.getRow(1).font = { bold: true, size: 14 }

      // 7. Ligne vide (A2), puis en‑têtes en A3
      ws.addRow([])
      ws.addRow(headers)

      // 8. Données dès la ligne 4
      exportData.forEach(r => ws.addRow(r))

      // 9. Ajuster largeur des colonnes
      ws.columns.forEach((col, i) => {
        const maxLen = Math.max(
          headers[i].length,
          ...exportData.map(r => (r[i] ? r[i].toString().length : 0))
        )
        col.width = maxLen + 2
      })

      // 10. Bordures fines noires et en‑têtes en gras
      ws.eachRow((row, rowIndex) => {
        row.eachCell(cell => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          }
        })
        if (rowIndex === 3) {
          row.font = { bold: true }
        }
      })

      // 11. Générer et télécharger
      const buf = await wb.xlsx.writeBuffer()
      const blob = new Blob([buf], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      })
      saveAs(blob, `${sheetName.toLowerCase()}_${new Date().toISOString().slice(0, 10)}.xlsx`)

      // 12. Confirmation
      this.$store.commit("app/message", {
        msg: this.$t("Fichier Excel exporté avec succès"),
        color: "success"
      })
    }
  }
}
</script>
